import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import colors from 'src/style/colors';
import { mediaQueries } from 'src/style/breakpoints';

const ProjectsShowcaseSection = () => {
  return (
    <>
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor: '#f8f8fa',
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '1rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
            },
          }}
        >
          Vous réaliserez d&apos;incroyables{' '}
          <span css={{ color: colors.purple }}>répliques</span>
        </h2>

        <p
          css={{
            textAlign: 'center',
            fontSize: '1.25rem',
            color: colors.darkGrey,
            marginBottom: '3rem',
            maxWidth: 750,
            lineHeight: 1.7,
            [mediaQueries.phoneOnly]: {
              fontSize: '1rem',
              marginBottom: '2rem',
            },
          }}
        >
          Tout au long de la formation, vous réalisez des projets issus de cas
          réels pour vous préparer au plus proche du monde professionnel — et
          construire votre portfolio.
        </p>

        <div css={{ width: '100%', maxWidth: 900, marginBottom: '3rem' }}>
          <StaticImage
            src="../../../data/images/project_screens2.png"
            alt="écrans des sites internet réalisés par les étudiants du Reacteur"
            css={{ width: '100%' }}
            objectFit="contain"
          />
        </div>

        <div
          css={{
            width: '60%',
            maxWidth: 700,
            [mediaQueries.phoneOnly]: {
              width: '90%',
            },
          }}
        >
          <StaticImage
            src="../../../data/images/project_logos.png"
            alt="logos des sites internet réalisés par les étudiants du Reacteur"
            css={{ width: '100%' }}
            objectFit="contain"
          />
        </div>

      </div>
    </section>

    {/* Peu importe d'où vous partez */}
    <section
      css={{
        padding: '5rem 2rem',
        backgroundColor: colors.white,
        [mediaQueries.phoneOnly]: {
          padding: '3rem 1rem',
        },
      }}
    >
      <div
        css={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <h2
          css={{
            textAlign: 'center',
            fontSize: '2.5rem',
            marginBottom: '2rem',
            color: colors.purpleDark,
            fontWeight: 700,
            [mediaQueries.phoneOnly]: {
              fontSize: '1.75rem',
            },
          }}
        >
          Peu importe d&apos;o&ugrave; vous partez,
          <br />
          <span css={{ color: colors.purple }}>vous pouvez apprendre &agrave; coder</span>
        </h2>

        <div
          css={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: '1.5rem',
            marginBottom: '2.5rem',
            [mediaQueries.phoneOnly]: {
              gap: '0.75rem',
            },
          }}
        >
          {[
            'Demandeur d\u2019emploi',
            'Salari\u00e9 en reconversion',
            '\u00c9tudiant',
            'Entrepreneur',
            'UI/UX Designer',
            'Product Owner',
          ].map((label) => (
            <span
              key={label}
              css={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem',
                fontSize: '1.1rem',
                color: colors.purpleDark,
                fontWeight: 500,
                [mediaQueries.phoneOnly]: {
                  fontSize: '0.95rem',
                },
              }}
            >
              <span css={{ color: colors.purple, fontWeight: 700, fontSize: '1.25rem' }}>
                &#10003;
              </span>
              {label}
            </span>
          ))}
        </div>

        <hr
          css={{
            width: '100%',
            maxWidth: 800,
            border: 'none',
            borderTop: '1px solid #e0e0e0',
            marginBottom: '2rem',
          }}
        />

        <p
          css={{
            textAlign: 'center',
            fontSize: '1.15rem',
            color: colors.darkGrey,
            lineHeight: 1.7,
            maxWidth: 750,
            [mediaQueries.phoneOnly]: {
              fontSize: '1rem',
            },
          }}
        >
          Depuis 2016, nous avons aid&eacute;{' '}
          <strong css={{ color: colors.purpleDark }}>plus de 3000 personnes</strong> &agrave;
          changer de vie — avec ou sans connaissances en code.
        </p>

        <div
          css={{
            width: '100%',
            maxWidth: 800,
            height: 280,
            marginTop: '2rem',
            borderRadius: 16,
            overflow: 'hidden',
            [mediaQueries.phoneOnly]: {
              height: 180,
            },
          }}
        >
          <StaticImage
            src="../../../data/images/2023_generalView.png"
            alt="Les élèves au Reacteur"
            css={{ width: '100%', height: '100%' }}
            objectFit="cover"
          />
        </div>
      </div>
    </section>
    </>
  );
};

export default ProjectsShowcaseSection;
